export default __webpack_public_path__ + "static/media/Login.448f50a4.png";